import { coalesceHotelHrCommissionPercent } from "./agentHotelPricingPipeline";

export const ENTITLEMENTS_PRICING_PENDING = "entitlements_pending";
export const ENTITLEMENTS_FAILED_FALLBACK_ZERO = "entitlements_failed_fallback_zero";

/**
 * @param {string|null|undefined} status — agentEntitlementsStatus from AppContext
 */
export function isHotelSearchEntitlementsPending(status) {
  if (status == null) return false;
  const s = String(status).trim().toLowerCase();
  return s === "idle" || s === "loading";
}

/**
 * @param {string|null|undefined} status
 */
export function isHotelSearchEntitlementsFailed(status) {
  if (status == null) return false;
  return String(status).trim().toLowerCase() === "error";
}

/**
 * Pending VM — no HR markup applied while entitlements are still loading.
 * @param {ReturnType<import("./agentHotelPricingPipeline").normalizeAgentHotelPricingInput>} normalized
 */
export function buildEntitlementsPendingHotelPricingVm(normalized) {
  const {
    basePrice,
    baseCurrency,
    resultsCurrency,
    displayCurrency,
    pricingSource,
  } = normalized;
  const flowCurrency = resultsCurrency ?? displayCurrency ?? baseCurrency ?? null;

  return {
    basePrice,
    baseCurrency: flowCurrency,
    commissionPercent: null,
    fixedHotelCommission: 0,
    commissionAmount: null,
    commissionIls: null,
    finalPrice: null,
    displayCurrency: flowCurrency,
    pricingSource,
    pricingStatus: ENTITLEMENTS_PRICING_PENDING,
    reason: ENTITLEMENTS_PRICING_PENDING,
    entitlementsTraceNote: ENTITLEMENTS_PRICING_PENDING,
    auditSteps: ["agent_hotel:entitlements_pending"],
  };
}

/**
 * @param {string|null|undefined} entitlementsStatus
 * @param {unknown} hotelHrCommissionPercentage
 */
export function resolveHotelHrCommissionForSearchPricing(
  entitlementsStatus,
  hotelHrCommissionPercentage
) {
  if (isHotelSearchEntitlementsPending(entitlementsStatus)) {
    return { mode: "pending", percent: null };
  }
  const percent = coalesceHotelHrCommissionPercent(hotelHrCommissionPercentage);
  if (isHotelSearchEntitlementsFailed(entitlementsStatus)) {
    return {
      mode: "failed_fallback",
      percent,
      traceNote: ENTITLEMENTS_FAILED_FALLBACK_ZERO,
    };
  }
  return { mode: "ready", percent, traceNote: null };
}
